export class UpdateBuyerTradeDataTransactionsError extends Error {}
